import axios from 'axios';

interface ApiErrorPayload {
  message?: unknown;
  errors?: unknown;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError<ApiErrorPayload>(error)) {
    const message = error.response?.data?.message;
    if (typeof message === 'string' && message.trim()) return message;

    const errors = error.response?.data?.errors;
    if (Array.isArray(errors)) {
      const messages = errors.filter((item): item is string => typeof item === 'string');
      if (messages.length) return messages.join(', ');
    }
  }

  return error instanceof Error && error.message ? error.message : fallback;
}
